import React from "react";

const SharesRedemption = () => {
  return <div>SharesRedemption</div>;
};

export default SharesRedemption;
